<template>
  <ChecklistItem
    title="3. Set up your service packages"
    description="Create offerings clients can purchase"
    :is-done="isDone"
    :editing="editing"
    @edit="startEdit"
    @done="finishEdit"
  >
    <template #default>
      <iColumn gap="standard" width="fill">
        <iRow align="between" width="fill">
          <iSubHeading font-size="extraLarge">
            My Packages
          </iSubHeading>
          <iButton size="small" @click="createServicePackage">
            Create Service Package
          </iButton>
        </iRow>
        <SmartFeed :source="useMyExpertServicePackageFeedStore" default-feed-layout="table" />
        <ExpertServicePackageModal />
      </iColumn>
    </template>
    <template #pitch>
      <iText font-size="standard">
        Start selling your expertise by creating service packages.
      </iText>
    </template>
    <template #summary>
      <iText font-size="standard">
        {{ packageCount }} package(s) configured
      </iText>
    </template>
  </ChecklistItem>
</template>

<script>
import ChecklistItem from "@/components/onboarding/ChecklistItem.vue";
import ExpertServicePackageModal from "@/components/expert-service-packages/ExpertServicePackageModal.vue";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { mapActions } from "pinia";
import { useExpertServicePackageStore } from "@/stores/expert-service-package-store";
import { useMyExpertServicePackageFeedStore } from "@/smart-feed/stores/feed/my-expert-service-package-feed-store";

export default {
  name: "PackagesChecklist",
  components: { ChecklistItem, SmartFeed, ExpertServicePackageModal },
  data() {
    return {
      editing: false,
    };
  },
  computed: {
    packageCount() {
      return useMyExpertServicePackageFeedStore().smartFeedEngine.entities?.length || 0;
    },
    isDone() {
      return this.packageCount > 0;
    },
  },
  methods: {
    ...mapActions(useExpertServicePackageStore, ["openExpertPackageModal"]),
    createServicePackage() {
      this.openExpertPackageModal("create");
    },
    startEdit() {
      this.editing = true;
    },
    finishEdit() {
      this.editing = false;
    },
    useMyExpertServicePackageFeedStore,
  },
};
</script>

<style scoped lang="scss">
</style>
